'use strict';

const isString = (value) => typeof value === "string";

exports.isString = isString;
